<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-comment-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Comment
            </h4>
          </div>

          <div class="modal-body">
            <TextareaFormGroup
                v-model="data.text"
                name="text"
                label="Text"
                :error="(errors.text ||[])[0]"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Block/Textarea'

export default {
  components: {TextareaFormGroup},

  props: {
    subject: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {},

      errors: {},
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $('#create-comment-modal').on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/comments', {...this.data, subject_type: this.subject.data.type, subject_id: this.subject.data.id.toString()} )
          .then(() => {
            notify.success('The comment was saved')

            this.$emit('created')

            $('#create-comment-modal').modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
